﻿import { FIQAssist } from "../app";
import { Component, Input, Output, Inject } from "@fiqas/angular-utils";

@Component({
    module: FIQAssist,
    selector: 'fqfiledrop',
    template: '<div class="droparea ng-class:{readonly:$ctrl.readOnly,dropping:$ctrl.isdropping}"></div>',
    transclude: true
})
export class FileDrop {
    @Output() public onfileover: (args: { status: boolean }) => void;
    @Output() public onfiledrop: (args: { filelist: FileList }) => void;
    @Input() public readOnly:boolean;
    private isdropping:boolean;
    constructor(
        @Inject('$element') private $element: angular.IRootElementService,
        @Inject('$transclude') private $transclude: angular.ITranscludeFunction,
        @Inject('$timeout') private $timeout: angular.ITimeoutService,
        @Inject('$scope') private $scope: angular.IScope
    ) {
        this.initTransclude(this.$transclude, this.$element);
        this.$element.on('drop', this.onDrop.bind(this));
        this.$element.on('dragover', this.onDragOver.bind(this));
        this.$element.on('dragleave', this.onDragLeave.bind(this));
    }

    initTransclude(transclude: angular.ITranscludeFunction, element: angular.IRootElementService) {
        transclude((e, s) =>
            element.children().append(e));
    }

    public onDrop(event: any): void {
        let transfer = this._getTransfer(event);
        if (this.readOnly || !transfer) {
            return;
        }
        this._preventAndStop(event);
        this.onfileover({ status: false });
        this.isdropping = false;
        this.onfiledrop({ filelist: transfer.files });
        this.$timeout(() => this.$scope.$digest());
    }

    public onDragOver(event: any): void {
        let transfer = this._getTransfer(event);
        if (this.readOnly || !this._haveFiles(transfer.types)) {
            return;
        }
        this.isdropping = true;
        transfer.dropEffect = 'copy';
        this._preventAndStop(event);
        this.onfileover({ status: true });
    }

    public onDragLeave(event: Event): any {
        if (event.currentTarget === this.$element[0]) {
            this.onfileover({ status: false });
            this.isdropping = false;
            return;
        }
        this._preventAndStop(event);
    }

    private _getTransfer(event: any): any {
        return event.dataTransfer ? event.dataTransfer : event.originalEvent.dataTransfer; // jQuery fix;
    }

    private _preventAndStop(event: any): any {
        event.preventDefault();
        event.stopPropagation();
    }

    private _haveFiles(types: any): any {
        if (!types) {
            return false;
        }

        if (types.indexOf) {
            return types.indexOf('Files') !== -1;
        } else if (types.contains) {
            return types.contains('Files');
        } else {
            return false;
        }
    }
    /*
      _addOverClass(item:any):any {
        item.addOverClass();
      }
    
      _removeOverClass(item:any):any {
        item.removeOverClass();
      }*/
}
